// https://www.npmjs.com/package/react-player
// infinite scroll https://www.youtube.com/watch?v=1EeVzn02grw
// https://github.com/CookPete/react-player#multiple-sources-and-tracks
// import playButton from "../../images/play-button.svg";
import React from "react";
import Link from "../Link";
import ThumbGallerySwiper from "./ThumbGallerySwiper";
// import ReactPlayer from "react-player";
import { useContext } from "react";
import ProductContext from "../contexts/ProductContext";
import Loader from "../site/Loader";
import clsx from "clsx";
const CustomSwiperItem = ({
  link,
  image,
  smallThumbs,
  title,
  imageAlt = "",
  category1,
  currency,
  originaPrice,
  salePrice,
  videoUrl,
  productId,
  hasLink,
  isImageOnly,
  isBigItem,
  className,
}) => {
  let cur =
    currency?.toLowerCase() === "usd"
      ? "$"
      : currency?.toLowerCase() === "cny"
      ? "¥"
      : currency;

  // const [showVideo, setShowVideo] = useState(false);
  // const shouldRenderVideo = !!videoUrl;
  // const handleVideoClick = (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   setShowVideo((prev) => !prev);
  // };
  // scoll top on image click
  // const handleTopSwiperClick = (e) => {
  //   if (!isImageOnly) {
  //     e.stopPropagation();
  //     e.preventDefault();
  //   } else {
  //     window.scrollTo(0, 550);
  //   }
  // };
  const context = useContext(ProductContext);
  const { fetchProduct, loadingBigItem } = context;
  const handleClickItem = (e) => {
    fetchProduct(productId);
  };
  return (
    <>
      <Link
        className={clsx("item swiper-generic-style", className)}
        productId={productId}
        hasLink={hasLink}
        link={link}
        newWindow={true}
        handleClickItem={(e) => handleClickItem()}
      >
        <div
          className="thumb-image-swiper"
          // onClick={() => handleTopSwiperClick()}
        >
          <ThumbGallerySwiper
            smallThumbs={smallThumbs}
            imageAlt={!!imageAlt ? imageAlt : "no title"}
            isImageOnly={isImageOnly}
          />
          {/* {showVideo && (
          <div className="player">
            <ReactPlayer
              className="react-player"
              url={videoUrl}
              controls={true}
              // playing={true}
              // loop={true}
              // muted={true}
              // playsinline={true}
            />
          </div>
        )} */}
        </div>
        <div className="info">
          <div className="wrap-info">
            {/* <div className="play-button-wrap">
          {shouldRenderVideo && (
            <div className="play-button" onClick={handleVideoClick}>
              {`${!showVideo ? "video" : "gallery"}`}
            </div>
          )}
        </div> */}
            <h2 className="category">{category1}</h2>
            <h1 className="title">{title}</h1>
            <div className="prices-wrap">
              <div className="price flex-it flex-align-item-center new-price">
                <div className="original-price">
                  {cur} {salePrice}
                </div>
              </div>
              <div className="price flex-it flex-align-item-center old-price">
                <strike>
                  {cur} {originaPrice}
                </strike>
              </div>
            </div>
            {isBigItem && <div className="checkout-btn">Checkout product</div>}
          </div>
        </div>
      </Link>
      {loadingBigItem && isBigItem && <Loader />}
    </>
  );
};

export default CustomSwiperItem;
